import { useEffect, useState } from "react";
import { FiEye } from "../../../../assets/icons/vander";
import { useSummaryProcedureStore } from "../../../../hooks";
import { LoadingData, ErrorMessage, SuccessMessage } from "../../../ui";
import { ViewComplicationDetailsModal } from "../modals";

export const SummaryProcedureTable = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    summaryProcedures,
    params,

    // Methods
    startGetSummaryProcedures,
  } = useSummaryProcedureStore();

  // States ------------------------------------------------//
  const [complicationDetails, setComplicationDetails] = useState([]);
  const [isViewComplicationDetailsModal, setIsViewComplicationDetailsModal] =
    useState(null);

  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  const openViewComplicationDetailsModal = (complicationDetails) => {
    setIsViewComplicationDetailsModal(true);
    setComplicationDetails(complicationDetails);
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (summaryProcedures.data.length === 0) {
      startGetSummaryProcedures(params);
    }
  }, [summaryProcedures.data, startGetSummaryProcedures, params]);

  return (
    <>
      {summaryProcedures.isLoading && <LoadingData className="mb-4" />}
      {summaryProcedures.message?.type === "error" && (
        <ErrorMessage className="mb-4">
          {summaryProcedures.message.text}
        </ErrorMessage>
      )}

      <div
        className="table-responsive shadow rounded"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <table className="table table-center bg-white mb-0">
          <thead>
            <tr>
              <th className="border-bottom p-3" style={{ minWidth: "50px" }}>
                #
              </th>
              <th className="border-bottom p-3">Doctor</th>
              <th className="border-bottom p-3"># Horas laboradas</th>
              <th className="border-bottom p-3"># Procedimientos</th>
              <th className="border-bottom p-3">
                # Procedimientos con complicaciones
              </th>
              <th className="border-bottom p-3">Detalles</th>
            </tr>
          </thead>
          <tbody>
            {summaryProcedures.data.map((summaryProcedure, index) => (
              <tr key={summaryProcedure.doctorId}>
                <th className="p-3">{index + 1}</th>
                <td className="py-3">{`${summaryProcedure.doctorName}`}</td>
                <td className="py-3">{`${summaryProcedure.hoursWorked}`}</td>
                <td className="py-3">{`${summaryProcedure.totalProcedures}`}</td>
                <td className="py-3">{`${summaryProcedure.proceduresWithComplications}`}</td>
                {summaryProcedure.complicationDetails.length > 0 && (
                  <td className="text-center py-3">
                    <button
                      to="#"
                      className="btn btn-icon btn-pills btn-soft-primary"
                      onClick={() =>
                        openViewComplicationDetailsModal(
                          summaryProcedure.complicationDetails
                        )
                      }
                    >
                      <FiEye />
                    </button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <ViewComplicationDetailsModal
        isOpen={isViewComplicationDetailsModal}
        setIsOpen={setIsViewComplicationDetailsModal}
        complicationDetails={complicationDetails}
      />
    </>
  );
};
